import React from 'react';
import ApiErrorProvider from '../lib/context-providers/api-error-context';
import CustomSettingsProvider from '../lib/context-providers/custom-settings-context';
import EventSettingsProvider from '../lib/context-providers/event-settings-context/event-settings-context';
import MediaQueryContextProvider from '../lib/context-providers/media-query-provider';
import AppRouter from './Router';
import { RoutesConfig } from '../config/routes';
import AuthProvider from '../lib/context-providers/auth-context';
import ErrorModal from './shared/ErrorModal';
import CookieNotificationWrapper from './shared/CookieNotificationWrapper/CookieNotificationWrapper';
import { AppConfigurationProvider, AppContextType, useApp } from '../lib/context-providers/app-config-context';
import { AppConfigurator } from '../lib/services/app-configuration/AppConfigurator';
import { AccountContextProvider } from '../lib/context-providers/account-context';
import { UrlRedirectionProvider } from '../lib/context-providers/url-redirection-context';
import { NotificationProvider } from './passport/NotificationWrapper/NotificationProvider';
import { IframeResizeDetector } from '../components/IframeResizeDetector';

type Props = {
  routes: RoutesConfig
}

function App(props: Props): JSX.Element {

  return (
    <div className='App'>
      {AppConfigurator.isPassportProfile
        ? (
          <IframeResizeDetector>
            <div className='router-wrapper h-screen w-full mx-auto overflow-auto' data-id="app">
              <AppRouter {...props} />
              <ApiErrorProvider>
                <ErrorModal/>
              </ApiErrorProvider>
              <CookieNotificationWrapper />
            </div>
          </IframeResizeDetector>
        )
        : (
          <div className='router-wrapper h-screen w-full mx-auto overflow-auto' data-id="app">
            <AppRouter {...props} />
            <ApiErrorProvider>
              <ErrorModal/>
            </ApiErrorProvider>
          </div>
        )}
    </div>
  );
}

function MeetLinksConfiguredApp(props: Props): JSX.Element | null {
  const { isConfigured } = useApp() as AppContextType;

  if (isConfigured !== true) {
    return null;
  }

  return <App {...props} />;
}

export default (props: Props): JSX.Element => {

  if (AppConfigurator.isPassportProfile) {

    return (
      <AppConfigurationProvider>
        <NotificationProvider>
          <AccountContextProvider>
            <UrlRedirectionProvider>
              <AuthProvider>
                <MediaQueryContextProvider>
                  <CustomSettingsProvider>
                    <EventSettingsProvider>
                      <App {...props} />
                    </EventSettingsProvider>
                  </CustomSettingsProvider>
                </MediaQueryContextProvider>
              </AuthProvider>
            </UrlRedirectionProvider>
          </AccountContextProvider>
        </NotificationProvider>
      </AppConfigurationProvider>
    );
  }

  if (AppConfigurator.isMeetLinksProfile) {
    return (
      <AppConfigurationProvider>
        <MeetLinksConfiguredApp {...props} />
      </AppConfigurationProvider>
    );
  }

  return <App {...props} />;
};
